module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABA0lEQVR4AdXQtUEsURgF4HMF6QILSSmAKohwDXGijbaArQCHGiBBEzTGIcPdx+fwD/Lc0fddd8GrU5KK+krxZ7ZqpjSAiDGZpKQCRhIgtVjiF51SJQArqb64jKBRxot8o7QSNsto43o3VhkASkDJaBrTFkBXSRNBBRAJpW24t0PXswX5igQlQUGqTKMVgl9zxyeuh4avenqdkVH6Ab8AQONrDMObudnw9iY2+mZxIbq6xPf4NX9t7bClZa+iwllc5NfwIHac2HUfo+fJId7ysrOwIBVpPnQ+jD7+0kkqRVJZS+myVgEqNxfGXA0NIStLAVJHcrT/uOAskwGJP6MhSPzP7gCG4+QRQicN1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IR.png
// module id = 1171
// module chunks = 0